// components/layout/NavLink.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Page } from '../../types/index';

// Mapping from Page type to route paths
const pageToRoute: Record<Page, string> = {
  'Home': '/',
  'About': '/about',
  'Services': '/services',
  'OurWork': '/our-work',
  'Gallery': '/gallery',
  'Testimonials': '/testimonials',
  'Contact': '/contact',
  'RequestQuote': '/request-quote',
  'Blog': '/blog'
};

interface NavLinkProps {
  page: Page;
  currentPage: Page;
  children: React.ReactNode;
  isButton?: boolean;
}

const NavLink: React.FC<NavLinkProps> = ({ page, currentPage, children, isButton }) => {
  const isActive = currentPage === page;
  const route = pageToRoute[page];

  if (isButton) {
    return (
      <Link
        to={route}
        className="relative px-6 py-2.5 bg-gradient-to-r from-lime-500 to-lime-600 hover:from-lime-600 hover:to-lime-700 text-white rounded-full font-medium shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 ease-out"
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      to={route}
      className={`relative px-4 py-2 rounded-lg font-medium transition-all duration-300 ease-out group ${
        isActive
          ? 'text-lime-400 bg-white/10'
          : 'text-gray-300 hover:text-white hover:bg-white/5'
      }`}
    >
      {children}
      <span className={`absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-lime-400 transition-all duration-300 ease-out ${
        isActive ? 'w-full' : 'w-0 group-hover:w-full'
      }`} />
    </Link>
  );
};

export default NavLink;
